import { Entity } from "@jobilla/entity";

export class OrderItemStatusHistory extends Entity {
  public status!: string;
  public userId!: number;
  public createdAt!: string;
}
